'use client';
/**
 * @file     useTheme.ts
 * @readme   ./README.md
 * @purpose  Backward-compatible alias that re-exports useAppTheme as useTheme.
 */
export { useAppTheme as useTheme } from './useAppTheme';
